<template>
  <LayoutSearchFieldVertical
    display-variant="list"
  >
    <template #header>
      <BaseToggleSwitch v-model="searchMap">{{
          lss('地図で検索', 'Search by map')
      }}</BaseToggleSwitch>
    </template>

    <div class="facet-buttons">
      <button
        class="fb-button"
        v-for="prefecture in prefectures"
        :class="{
          'is-0': count(prefecture.key) === 0,
          'is-exclude': exclude,
          'is-selected': isSelected('+' + prefecture.key),
        }"
          @click="select(prefecture.key)"
          v-show="showAll || prefecture.isDefault"
          :key="prefecture.key"
      >
        <span class="fb-label">{{ display(prefecture) }}</span>
        <span class="fb-count" :title="num(count(prefecture.key))" v-if="facet !== null">{{
            facetNum(count(prefecture.key))
          }}</span>
      </button>
    </div>

    <template #nav>
      <button
        class="jps-text-button"
        @click="showAll = !showAll"
      >
        {{
          showAll
            ? ls(dapLangGlobal.hide)
            : lss('すべての選択肢を表示', 'Show all')
        }}
      </button>
    </template>

    <template #options>
      <BaseToggleSwitch class="is-red" v-model="exclude">{{
          lss('除外条件を指定', 'Exclude')
        }}</BaseToggleSwitch>
    </template>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'
import type { Prefecture } from '~/components/search/useSearchField'
import { PREFECTURES } from '~/components/search/useSearchField'

const { ls, lss, num } = useI18n()
const { isHina } = useServiceType()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { facet, excludeDisplay, facetNum } = useSearchFieldBase(props)

const prefectures: Prefecture[] = clone(PREFECTURES);

const exclude: Ref<boolean> = ref(false)
function count(key: string) {
  if (!facet.value) return undefined
  return facet.value.counts[key] || 0
}
const isSelected = (key: string) => {
  return props.ss.state.filter[props.field.key]?.includes(key)
}

const select = (key: string) => {
  if (exclude.value) key = '-' + key
  else key = '+' + key
  if (isSelected(key)) {
    props.ss.removeFilter(props.field.key, [key])
  } else {
    props.ss.addFilter(props.field.key, [key])
  }
}

const showAll = ref(false)

const display = (prefecture: Prefecture) => {
  return excludeDisplay(ls(prefecture.name), exclude.value, count(prefecture.key))
}

const updateSearchFrom = () => {
  // 画像検索の場合はfromを0からに戻すことで無限にページング検索が実行される場合を防ぐ
  if (props.ss.state.image && props.ss.state.image.length > 0) {
    props.ss.state.from = 0
  }
}

const searchMap: Ref<boolean> = ref(false)
let beforeSearchSort = null
let beforeSearchSize = null
watch(
  () => searchMap.value,
  () => {
    if (searchMap.value) {
      // トグルをオンにした時の操作
      // 地図検索に変更する
      updateSearchFrom()
      beforeSearchSort = props.ss.state.sort
      beforeSearchSize = props.ss.state.size
      props.ss.state.geoDistance[props.field.key] = [
        { lat: 35.3622222, lon: 138.7313889, distance: isHina ? '400km' : '100km' },
      ]
      props.ss.state.sort = ['geo:' + props.field.key]
      props.ss.state.size = 500
      props.ss.execute()
    } else if (props.ss.state.geoDistance[props.field.key]) {
      // 通常検索に戻す
      // 検索条件を見ている理由はサーチボックス側で検索条件のリセットした場合にもこちらの処理に入ってしまうため
      updateSearchFrom()
      if (beforeSearchSort) {
        props.ss.state.sort = beforeSearchSort
      }
      if (beforeSearchSize) {
        props.ss.state.size = beforeSearchSize
      }
      props.ss.state.geoDistance[props.field.key] = undefined
      props.ss.execute()
    }
  }
)
watch(
  () => props.ss.state.geoDistance[props.field.key],
  () => {
    if (!props.ss.state.geoDistance[props.field.key]) {
      searchMap.value = false
    }
  }
)
</script>
